module.exports = __webpack_public_path__ + "static/media/pf24.36ce6dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf24.png
// module id = 2660
// module chunks = 0